import { fetcher } from 'services/helpers/responseHandler'

const getList = () => fetcher.get('widgets/list')

const saveList = ({ data, isDraft = false }) =>
  fetcher.post('widgets', { widgets: data, isDraft })

const getUploadedFile = kind => fetcher.get(`widgets/files`, { kind })

const analytics = ({ fromDate, toDate }) =>
  fetcher.get('widgets/analytics', { fromDate, toDate })

const checkStatus = () => fetcher.get('widgets/check')

const updatePromotion = ({
  contentId,
  promotionCode,
  minNightsToStay,
  maxDiscountPercentage,
  promotionTagline
}) =>
  fetcher.put('widgets/promotion', {
    contentId,
    promotionCode,
    minNightsToStay,
    maxDiscountPercentage,
    promotionTagline
  })

const widgetsApi = {
  analytics,
  list: {
    get: getList,
    post: saveList
  },
  files: {
    get: getUploadedFile
  },
  checkStatus,
  updatePromotion
}

export default widgetsApi
